export const visit = (vm, at) => {
at({ "en": { "marketingEventLib": { "hosted": "Hosted on:", "status": { "upcoming": "Upcoming", "cancelled": "Cancelled", "ongoing": "Ongoing", "finished": "Completed" } } } });
};